const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Button = FuzzyReaction.Components.Global.Button;
const Column = Form.Column;
const Row = Form.Row;
const FormStore = FuzzyReaction.Stores.FormStore;
const PushMessagesStore = require('../../../stores/PushMessagesStore');
const PushTemplatesStore = require('../../../stores/PushTemplatesStore');
const CohortsStore = require('../../../stores/CohortsStore');
const DayTimePicker = require("../../../components/global/components/DayTimePicker.js");
const Scheduling = require('../Scheduling');
const Status = require('../Status');
const _ = require("lodash");

const PushManagement = createReactClass({
    displayName: 'PushManagement',

    getInitialState: function () {
        return {
            workingResource: {
                channel: 'push',
                scheduling: Scheduling.ONCE_NOW,
                cohort: null,
                template: null,
                allow_duplicate_sends: 0,
                stop_behavior: 'never',
            },
            saving: false
        }
    },

    resourceActions: new ResourceActions('push-messages'),
    templatesResourceActions: new ResourceActions('push-templates'),
    templatesTypeAheadResourceActions: new ResourceActions('push-templates'),
    cohortsResourceActions: new ResourceActions('cohorts'),
    cohortsTypeAheadResourceActions: new ResourceActions('cohorts'),

    /**
     * Edit push form key
     */
    formKey: 'pushForm',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    _validateSavePush: function () {
        const pushData = this.state.workingResource;

        return !this.state.saving &&
            pushData &&
            pushData.status !== Status.COMPLETED &&
            pushData.name &&
            (pushData.stop_behavior == null || (pushData.stop_behavior === 'date' && pushData.stop_at) || pushData.stop_behavior === 'never');
    },

    _validateSendPush: function () {
        const pushData = this.state.workingResource;

        return this._validateSavePush() &&
            pushData.template &&
            pushData.template.length === 1 &&
            pushData.cohort &&
            pushData.cohort.length === 1 &&
            (pushData.scheduling === Scheduling.ONCE_NOW
                || (pushData.scheduling === Scheduling.ONCE_LATER && pushData.start_at)
                || (pushData.scheduling === Scheduling.AS_MET && pushData.start_at &&
                    ((pushData.stop_behavior === 'date' && pushData.stop_at) || pushData.stop_behavior === 'never')));
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};

        PushMessagesStore.addChangeListener(this._onPushChange);
        PushTemplatesStore.addChangeListener(this._onTemplateChange);
        CohortsStore.addChangeListener(this._onCohortChange);
        FormStore.addChangeListener(this.bindResource);

        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            // An existing push
            if (this.state.resourceOperation === 'edit') {
                this.requestPush(params.id);
            }
        });
    },

    /**
     * Request push, if editing
     *
     * @param id
     */
    requestPush: function (id) {
        this.resourceActions.getResource(id, this.getOptions);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        PushMessagesStore.removeChangeListener(this._onPushChange);
        PushTemplatesStore.removeChangeListener(this._onTemplateChange);
        CohortsStore.removeChangeListener(this._onCohortChange);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Handle change events
     */

    _onPushChange: function () {
        this.setState({
            saving: false,
            workingResource: PushMessagesStore.getResource(),
        }, function () {
            FormStore.syncForm(this.formKey, this.state.workingResource);

            if (this.state.workingResource.template_id) {
                this.requestPushTemplate(this.state.workingResource.template_id)
            }
            if (this.state.workingResource.cohort_id) {
                this.requestCohort(this.state.workingResource.cohort_id)
            }
        });
    },

    _onTemplateChange: function () {
        this.setState((prevState) => ({
            workingResource: Object.assign({}, prevState.workingResource, {template: [PushTemplatesStore.getResource()]})
        }), function () {
            FormStore.syncForm(this.formKey, this.state.workingResource);
        });
    },

    _onCohortChange: function () {
        this.setState((prevState) => ({
            workingResource: Object.assign({}, prevState.workingResource, {cohort: [CohortsStore.getResource()]})
        }), function () {
            FormStore.syncForm(this.formKey, this.state.workingResource);
        });
    },

    /**
     * Change handler for FormStore changes
     */
    bindResource: function () {
        this.setState({
            workingResource: FormStore.getResource(this.formKey),
        }, function () {
            this.forceUpdate(); // Yes, this is required in order to force the conditionally rendered stuff to be re-rendered.
        });
    },

    /**
     * Action handlers
     *
     * @param action
     */
    handleAction: function (action) {
        switch (action) {
            case 'save':
                if (this._validateSavePush()) {
                    this.createOrUpdateResource(action);
                }
                break;
            case 'save-send':
                if (this._validateSendPush()) {
                    this.createOrUpdateResource(action);
                }
                break;
            case 'goBack':
                this.transitionToLibrary()
                break;
        }
    },

    createOrUpdateResource: function (action) {
        if (this.state.saving) {
            return;
        }
        this.setState({
            saving: true
        }, function () {
            let pushData = _.cloneDeep(this.state.workingResource)

            if (pushData.template) {
                pushData.template_id = pushData.template[0].id;
                delete pushData.template;
            }

            if (pushData.cohort) {
                pushData.cohort_id = pushData.cohort[0].id;
                delete pushData.cohort;
            }

            switch (pushData.scheduling) {
                case Scheduling.ONCE_NOW:
                    pushData.start_at = new Date().toISOString();
                    pushData.stop_at = null;
                    break;
                case Scheduling.ONCE_LATER:
                    pushData.stop_at = null;
                    break;
                case Scheduling.AS_MET:
                    if (pushData.stop_behavior === 'never') {
                        pushData.stop_at = null;
                        delete pushData.stop_behavior;
                    }
                    break;
            }

            action === 'save' ? pushData.status = Status.DRAFT : pushData.status = Status.PENDING;

            if (!pushData.allow_duplicate_sends) {
                pushData.allow_duplicate_sends = 0;
            }

            if (typeof pushData.id === 'undefined') {
                this.resourceActions.createResource(pushData, this.sendOptions);
            } else {
                this.resourceActions.updateResource(pushData, this.sendOptions);
            }
        });
    },

    /**
     * Direct the user back to the music library
     */
    transitionToLibrary: function () {
        this.props.history.push('/push-messages');
    },

    /**
     * Fire request action for push templates
     */
    requestPushTemplate: function (template_id) {
        this.templatesResourceActions.getResource(template_id, this.getOptions);
    },

    /**
     * Fire request action for cohorts
     */
    requestCohort: function (cohort_id) {
        this.cohortsResourceActions.getResource(cohort_id, this.getOptions);
    },

    stopBehaviorOptions: [
        {
            label: 'Never',
            value: 'never'
        },
        {
            label: 'Specific Date',
            value: 'date'
        }
    ],

    render: function () {
        const disableSave = this._validateSavePush() ? null : 'disabled';
        const disableSend = this._validateSendPush() ? null : 'disabled';
        const formDisabled = this.state.workingResource.status === Status.COMPLETED;

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row>
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Manage Push Message</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="12">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="12">
                                        <Form key={this.formKey + this.state.workingResource.id} formKey={this.formKey}
                                              bindResource={this.state.workingResource}>
                                            <Row>
                                                <Column grid="lg" size="4">
                                                    <Form.Input fieldKey="name" type="text" label="Message Name"
                                                                placeholder="Push Message Name" limit={255}
                                                                validations="isLength:1:255"
                                                                required="true" disabled={formDisabled}/>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="4">
                                                    <Form.TypeAheadInput fieldKey="template" source="remote"
                                                                         resourceAction={this.templatesTypeAheadResourceActions}
                                                                         label="Push Template"
                                                                         placeholder="Search templates.."
                                                                         limit={1} fields={['name']}
                                                                         options={{}} disabled={formDisabled}/>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="4">
                                                    <Form.TypeAheadInput fieldKey="cohort" source="remote"
                                                                         resourceAction={this.cohortsTypeAheadResourceActions}
                                                                         label="Target Cohort"
                                                                         placeholder="Search cohorts.."
                                                                         limit={1} fields={['name']}
                                                                         options={{}} disabled={formDisabled}/>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="6">
                                                    <Form.Checkbox fieldKey="allow_duplicate_sends"
                                                                   label="Duplicate Deliveries"
                                                                   options={[{
                                                                       name: 'allow_duplicate_sends',
                                                                       value: 1,
                                                                       label: "Allow sending this message multiple times"
                                                                   }]}
                                                                   disabled={formDisabled}/>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="4">
                                                    <Form.SelectBox fieldKey="scheduling"
                                                                    label="Scheduling"
                                                                    options={Scheduling.SCHEDULING_OPTIONS}
                                                                    disabled={formDisabled}/>
                                                </Column>
                                                {this.state.workingResource.scheduling === Scheduling.AS_MET &&
                                                    <Column grid="lg" size="4">
                                                        <Form.SelectBox fieldKey="stop_behavior"
                                                                        label="End Behavior"

                                                                        options={this.stopBehaviorOptions}
                                                                        disabled={formDisabled}/>
                                                    </Column>
                                                }
                                            </Row>

                                            {this.state.workingResource.scheduling && this.state.workingResource.scheduling !== Scheduling.ONCE_NOW &&
                                                <Row>
                                                    <DayTimePicker fieldKey="start_at" label={"Start At"}
                                                                   disabled={formDisabled}/>
                                                    {this.state.workingResource.scheduling === Scheduling.AS_MET && this.state.workingResource.stop_behavior === 'date' &&
                                                        <DayTimePicker fieldKey="stop_at" label={"End At"}
                                                                       disabled={formDisabled}/>
                                                    }
                                                </Row>
                                            }
                                        </Form>
                                    </Column>
                                </Row>
                                <Row classes="justify-content-end">
                                    <Button action="goBack" text="Go Back" handleAction={this.handleAction}/>
                                    <Button action="save" text="Save as Draft" handleAction={this.handleAction}
                                            mods={[disableSave]}/>
                                    <Button action="save-send" text="Save and Start Sending"
                                            handleAction={this.handleAction}
                                            mods={['primary', disableSend]}/>
                                </Row>
                            </div>
                        </div>
                    </Column>
                </div>
            </div>
        )
    },
});

module.exports = PushManagement;
